import type { MdxPayload } from "../types";

/**
 * Stub. MDX support is reserved for Phase 2; this runner is here so the
 * dispatcher can resolve `renderer: "mdx"` without runtime errors when a
 * mission marks itself MDX.
 *
 * When implementing for real, use @mdx-js/mdx and pass our primitives as
 * `components={{ MultipleChoice, DragSort, ... }}`.
 */
interface Props {
  payload: MdxPayload;
  onScored: (result: { score: number; passed: boolean; raw: unknown }) => void;
}

export function MdxRunner({ payload, onScored: _onScored }: Props) {
  void _onScored;
  return (
    <div style={{ padding: 16 }}>
      <h2>MDX renderer pendiente</h2>
      <p style={{ fontSize: 14, color: "#6b7280" }}>
        Esta misión usa <code>renderer: "mdx"</code> que aún no está
        implementado en el runner. Schema version recibida:{" "}
        <code>{payload.renderer}</code>.
      </p>
      <pre style={{ fontSize: 12, background: "#f9fafb", padding: 12, borderRadius: 8 }}>
        {payload.source.slice(0, 400)}
      </pre>
    </div>
  );
}
